// Mobile sticky add-to-cart bar. Mirrors the main product form's submit button and clicks it,
// so variant, quantity and Sense's cart notification/drawer keep working untouched.
if (!customElements.get('pv-sticky-atc')) {
  customElements.define(
    'pv-sticky-atc',
    class PvStickyAtc extends HTMLElement {
      connectedCallback() {
        // Quick-add modals copy product-info's markup; the bar only belongs on the product page.
        if (this.closest('quick-add-modal')) return this.remove();
        this.source = document.getElementById(this.dataset.button);
        if (!this.source) return;
        this.priceSource = document.getElementById(this.dataset.price);
        this.button = this.querySelector('button');
        this.priceEl = this.querySelector('.pv-sticky-atc__price');
        this.button.addEventListener('click', () => this.source.click());

        this.passed = false;
        this.atFooter = false;
        const update = () => this.toggle(this.passed && !this.atFooter);
        // The root reaches far below the viewport, so "not intersecting" means the main button has
        // scrolled up out of view. A plain observer misses fast jumps straight past the button.
        this.io = new IntersectionObserver(
          ([entry]) => {
            this.passed = !entry.isIntersecting;
            update();
          },
          { rootMargin: '0px 0px 100000px 0px' }
        );
        this.io.observe(this.source);
        this.footerIo = new IntersectionObserver(([entry]) => {
          this.atFooter = entry.isIntersecting;
          update();
        });
        const footer = document.querySelector('footer');
        if (footer) this.footerIo.observe(footer);

        this.mo = new MutationObserver(() => this.sync());
        const opts = { attributes: true, childList: true, subtree: true, characterData: true };
        this.mo.observe(this.source, opts);
        if (this.priceSource) this.mo.observe(this.priceSource, opts);
        this.sync();
      }

      disconnectedCallback() {
        this.io?.disconnect();
        this.footerIo?.disconnect();
        this.mo?.disconnect();
        document.body.classList.remove('pv-sticky-atc-open');
      }

      sync() {
        this.button.disabled = this.source.disabled || this.source.getAttribute('aria-disabled') === 'true';
        const label = this.source.querySelector('span')?.textContent.trim();
        if (label) this.button.textContent = label;
        const price =
          this.priceSource?.querySelector('.price--on-sale .price-item--sale') ||
          this.priceSource?.querySelector('.price__regular .price-item--regular');
        if (price) this.priceEl.textContent = price.textContent.trim();
      }

      toggle(show) {
        if (show === this.shown) return;
        this.shown = show;
        this.classList.toggle('is-visible', show);
        this.toggleAttribute('inert', !show);
        this.setAttribute('aria-hidden', String(!show));
        if (show && this.offsetHeight) document.body.style.setProperty('--pv-sticky-atc-h', `${this.offsetHeight}px`);
        document.body.classList.toggle('pv-sticky-atc-open', show);
      }
    }
  );
}
